import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { googleCallback } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    // useRef-flag voorkomt dubbele verwerking onder StrictMode
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    googleCallback(sessionId)
      .then(() => {
        toast.success("Welkom terug!");
        nav("/admin", { replace: true });
      })
      .catch((err) => {
        toast.error(formatApiErrorDetail(err.response?.data?.detail));
        nav("/login", { replace: true });
      });
  }, [location, nav, googleCallback]);

  return (
    <div className="min-h-screen grid place-items-center bg-background text-text-muted" data-testid="auth-callback-loading">
      Even geduld, je wordt ingelogd met Google...
    </div>
  );
}
